/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import FormatPrice from "../formatters/FormatPrice";
import { useTranslate } from "../../hooks/useTranslate";
import { formatMembershipDuration } from "../../utils/helpers/membership";

const joinSegments = (segments) =>
  segments
    .filter(Boolean)
    .reduce((acc, seg, i) => (i === 0 ? [seg] : acc.concat(" · ", seg)), []);

const MembershipMetadata = ({ item }) => {
  const { _t } = useTranslate();

  if (!item) return null;
  const segments = [];

  const durationLabel = formatMembershipDuration(item.duration, item.duration_type, _t);
  if (durationLabel) segments.push(durationLabel);

  if (item.is_unlimited) {
    segments.push(_t("Unlimited"));
  } else if (item.limit) {
    const sessionsLabel = item.limit > 1 ? _t("sessions") : _t("session");
    
    segments.push(_t("%limit% %sessions%", { limit: item.limit, sessions: sessionsLabel }));
  }

  if (item.is_recurring && item.recurring_price > 0) {
    segments.push(
      <>
        {_t("renew for")}{" "}
        <FormatPrice value={item.recurring_price} currency={item.currency} />
      </>
    );
  }

  if (segments.length === 0) return null;

  return joinSegments(segments).map((node, i) => (
    <React.Fragment key={i}>{node}</React.Fragment>
  ));
};

export default MembershipMetadata;
